/**
 * User Redux Reducer
 */

import { stripeToken } from '../../tests/mocks/stripeTokenMock';

import * as action from '../actions/user';

import { CognitoUser, CognitoUserSession } from 'amazon-cognito-identity-js';
import { Success } from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

type ReducerState = IUserState;
type Handler<K = undefined> = ReducerHandler<ReducerState, K>;
type LogInSuccessHandler = Handler<Success<IUserCredentials, CognitoUserSession>>;
type SignUpSuccessHandler = Handler<Success<IUserCredentials, CognitoUser>>;

const initialState: ReducerState = {
  isLoggedIn: false,
  stripeToken,
};

const setViewerIdHandler: Handler<ISetViewerIdActionPayload> =
  (state, { viewerId }) => ({
    ...state,
    viewerId,
  });

const setUserLoginStatusHandler: Handler<boolean> = (state, isLoggedIn) => ({ ...state, isLoggedIn });

const setUserDetailHandler: Handler<ISetUserDetailActionPayload> =
  (state, { key, value }) => ({
    ...state,
    registrationForm: {
      ...state.registrationForm,
      [key]: value,
    },
  });

const setUserProfileHandler: Handler<ISetUserProfileActionPayload> =
  (state, { profile }) => ({ ...state, profile });

const setCognitoUserHandler: Handler<CognitoUser> =
  (state, cognitoUser) => ({ ...state, cognitoUser });

const userLogInDoneHandler: LogInSuccessHandler =
  (state, success) => {
    return {
      ...state,
      cognitoSession: success.result,
    };
  };

const userSignUpDoneHandler: SignUpSuccessHandler =
  (state, success) => {
    return {
      ...state,
      cognitoUser: success.result,
    };
  };

const setUserStripeTokenHandler: Handler<ISetUserStripeTokenActionPayload> =
  (state, { token }) => ({
    ...state,
    stripeToken: token,
  });

export default reducerWithInitialState(initialState)
  .case(action.setUserProfile, setUserProfileHandler)
  .case(action.setViewerId, setViewerIdHandler)
  .case(action.setUserLoginStatus, setUserLoginStatusHandler)
  .case(action.setUserDetail, setUserDetailHandler)
  .case(action.setCognitoUser, setCognitoUserHandler)
  .case(action.setUserStripeToken, setUserStripeTokenHandler)
  .case(action.logInUser.done, userLogInDoneHandler)
  .case(action.signUpUser.done, userSignUpDoneHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/user.ts